module.exports = __webpack_public_path__ + "static/DSC_9494-fc5cd4d28473f59b408960b6bd98e574.jpg";